/*
 * @Author: ITDLCL
 * @Date: 2025-03-28 10:14:21
 * @LastEditors: ITDLCL
 * @Description: 高能APP原生方法
 */

/**
 * 判断app环境 IOS,Android,Wx浏览器 isIOS=true在微信浏览器下再次判断是否是IOS手机
 */
export function IsApp (isIOS = false) {
  if (/(MicroMessenger)/i.test(navigator.userAgent)) {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) && isIOS) {
      return "IOS";
    }
    return "WX";
  } else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    return "IOS";
  } else if (/(Android)/i.test(navigator.userAgent)) {
    return "Android";
  } else {
    return "未知";
  }
};

const isApp = IsApp();
/**
 * 关闭webview
 */
export function openNativeClosePage () {
  if (isApp == "IOS") {
    window.webkit.messageHandlers.jumpToClose.postMessage({ close: true });
  } else if (isApp == "Android") {
    window.android.androidFinishWeb();
  } else if (isApp == "WX") {
    window.history.back();
  }
}
